import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSentryComponent } from './simple-icons-sentry.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSentryComponent ],
    exports:      [ SimpleIconsSentryComponent ],
    bootstrap:    []
})
export class SimpleIconsSentryModule {}
